import React, { PureComponent } from 'react';
import SuggestionsList from 'modules/homescreen/components/SuggestionsList';
import { Translator } from 'Translator';

type SuggestionListDeciderProps = {
  onSuggestionChange: (suggestion: { city: string; country: string }, lockIn?: boolean) => void;
  recentSearches: any;
  suggestions: any;
  popularLocations: any;
  approvedLocations: any;
  selectedSuggestion: { city: string; country: string; place: string };
};

function stringEquals(given, expected) {
  const upperCaseGiven = given && given.toUpperCase();
  const upperCaseExpected = expected && expected.toUpperCase();
  return upperCaseGiven === upperCaseExpected;
}

class SuggestionListDecider extends PureComponent<SuggestionListDeciderProps> {

  onSuggestionChange = (suggestion: { city: string; country: string }, lockIn = false) => {
    this.props.onSuggestionChange(suggestion, lockIn);
  };

  getListTitle = () => {
    const suggestionType = this.getSuggestionType();
    switch (suggestionType) {
      case 'popularlocations':
        return Translator.translate('UserEnvironment.LocationFilter.popularDestinations', {}, true, 'Popular Destinations');
      case 'recentsearches':
        return Translator.translate('UserEnvironment.LocationFilter.recentSearches', {}, true, 'Recent searches');
      default:
        return null;
    }
  };

  getSuggestions = (): { city: string; country: string; place: string }[] => {
    const suggestionType = this.getSuggestionType();
    switch (suggestionType) {
      case 'suggestions':
        return this.props.suggestions;
      case 'popularlocations':
        return this.props.popularLocations.map(item => ({
          city: item.location.city,
          country: item.location.country,
          isComingSoon: !!this.props.approvedLocations.find(f => f.isComingSoon && f.area === item.location.city && f.country === item.location.country),
        }));
      case 'recentsearches':
        return this.props.recentSearches.map(({ city, country, isNew }) => ({ city, country, isNew, isComingSoon: !!this.props.approvedLocations.find(f => f.isComingSoon && f.area === city && f.country === country) }));
      default:
        return [];
    }
  };

  getSuggestionType = (): 'suggestions' | 'popularlocations' | 'recentsearches' | 'other' => {
    const { recentSearches, suggestions } = this.props;

    if (suggestions.length !== 0) {
      return 'suggestions';
    }

    if ((!recentSearches || recentSearches.length === 0) && suggestions.length === 0) {
      return 'popularlocations';
    }

    if (!suggestions || suggestions.length === 0) {
      return 'recentsearches';
    }

    return 'other';
  };

  public getFirstSuggestion = (): { city: string; country: string; place: string } => {
    const suggestion = this.getSuggestions()[0];
    return {
      city: suggestion.city,
      country: suggestion.country,
      place: suggestion.place,
    };
  };

  public selectNextSuggestion = () => {
    const suggestions = this.getSuggestions();
    const { selectedSuggestion } = this.props;
    const selectedSuggestionIndex = suggestions.findIndex(suggestion =>
      (
        stringEquals(suggestion.city, selectedSuggestion.city) &&
        stringEquals(suggestion.country, selectedSuggestion.country) &&
        stringEquals(suggestion.place, selectedSuggestion.place)
      )
    );
    this.suggestionList.focusNextSuggestion(selectedSuggestionIndex);
  };

  public selectPreviousSuggestion = () => {
    const suggestions = this.getSuggestions();
    const { selectedSuggestion } = this.props;
    const selectedSuggestionIndex = suggestions.findIndex(suggestion =>
      (
        stringEquals(suggestion.city, selectedSuggestion.city) &&
        stringEquals(suggestion.country, selectedSuggestion.country) &&
        stringEquals(suggestion.place, selectedSuggestion.place)
      )
    );
    this.suggestionList.focusPreviousSuggestion(selectedSuggestionIndex);
  };
  suggestionList: SuggestionsList;

  setRef = c => this.suggestionList = c;

  render() {
    return (
      <SuggestionsList
        suggestionType={this.getSuggestionType()}
        ref={this.setRef}
        title={this.getListTitle()}
        onSuggestionChange={this.onSuggestionChange}
        suggestions={this.getSuggestions()}
        selectedSuggestion={this.props.selectedSuggestion}
      />
    );
  }
}

export default SuggestionListDecider;
